export default function normalizeSlug(str) {
  const numericsReplaced = str.replace(/^[0-9]/, '')
  return numericsReplaced.split('-').join('_')
}
